var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1442 902",
    style: {
      enableBackground: "new 0 0 1442 902"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000079460605487148230730000005179916892128033941_);fill:url(#SVGID_00000019675107970492735470000002058171014942837913_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000079460605487148230730000005179916892128033941_);fill:url(#SVGID_00000098217485341854355190000001967113535390662551_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000079460605487148230730000005179916892128033941_);fill:url(#SVGID_00000164493625283874689260000001663789075358386319_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000079460605487148230730000005179916892128033941_);fill:url(#SVGID_00000134939982894445226730000011420388296807542967_);fill-opacity:0.4;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1442,
    height: 902
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085211412614435142140000011549059204325833864_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095317237722241083100000001015366934371989951_",
    gradientUnits: "userSpaceOnUse",
    x1: 324.0936,
    y1: 1107.7946,
    x2: 1051.0953,
    y2: -85.1952,
    gradientTransform: "matrix(1 0 0 -1 0 904)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CDDDEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    style: {
      stopColor: "#EAEFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4825,
    style: {
      stopColor: "#EEF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7224,
    style: {
      stopColor: "#DBE5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    style: {
      stopColor: "#BAC2E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000085211412614435142140000011549059204325833864_)",
      fill: "url(#SVGID_00000095317237722241083100000001015366934371989951_)"
    },
    d: " M8-3.8h1429.8c6.7,0,12.1,5.4,12.1,12.1v884.5c0,6.7-5.4,12.1-12.1,12.1H8c-6.7,0-12.1-5.4-12.1-12.1V8.3C-4.1,1.6,1.3-3.8,8-3.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000126284304374290461280000017740605308222598810_",
    cx: -237.775,
    cy: 991.6224,
    r: 1.0103,
    gradientTransform: "matrix(262.4999 -283.0001 -452.7999 -419.9995 511357.9375 350207.5312)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000085211412614435142140000011549059204325833864_)",
      fill: "url(#SVGID_00000126284304374290461280000017740605308222598810_)"
    },
    d: " M5.7-2.4h1430.6c6.7,0,12.1,5.4,12.1,12.1v885c0,6.7-5.4,12.1-12.1,12.1H5.7c-6.7,0-12.1-5.4-12.1-12.1V9.7C-6.4,3-1-2.4,5.7-2.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000099642364778684667180000009334343707365148050_",
    cx: -238.2026,
    cy: 992.1401,
    r: 1.0097,
    gradientTransform: "matrix(-751.9991 421.5018 674.4011 1203.1954 -846778.6875 -1093339.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    style: {
      stopColor: "#FFFAEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFF8F3",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000085211412614435142140000011549059204325833864_)",
      fill: "url(#SVGID_00000099642364778684667180000009334343707365148050_)"
    },
    d: " M8-3.8h1429.8c6.7,0,12.1,5.4,12.1,12.1v884.5c0,6.7-5.4,12.1-12.1,12.1H8c-6.7,0-12.1-5.4-12.1-12.1V8.3C-4.1,1.7,1.3-3.8,8-3.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000058548845383313440790000015243922262628368019_",
    cx: -238.57,
    cy: 992.1451,
    r: 1.0105,
    gradientTransform: "matrix(-426.4999 19.0017 30.4028 682.4001 -130427.5312 -672164.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFAFC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6C8FF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000085211412614435142140000011549059204325833864_)",
      fill: "url(#SVGID_00000058548845383313440790000015243922262628368019_)",
      fillOpacity: 0.4
    },
    d: " M7.1-2.4H1438c6.7,0,12.1,5.4,12.1,12.1v885.2c0,6.7-5.4,12.1-12.1,12.1H7.1c-6.7,0-12.1-5.4-12.1-12.1V9.7C-5,3,0.4-2.4,7.1-2.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.c346b1e081e3a7cdeed14ab258025643.svg";
export { ForwardRef as ReactComponent };